module.exports = __webpack_public_path__ + "img/hotel1.bbf4b582.png";